import React from "react";
import TableOuterLabel from "../../../components/Table/TableOuterLabel";
import Table from "../../../components/Table/Table";
import AssignmentListTr from "./AssignmentListTr";
import Loading from "../../../components/Ui/Loading";
import Error from "../../../components/Ui/Error";
import {
  useDeleteAssignmentMutation,
  useGetAssignmentsQuery,
} from "../../../features/Admin/Assignments/assignmentsApi";

const headers = ["Title", "Video Title", "Mark", "Action"];

export default function Assignment() {
  // *****************************************************DECLARATION START******************************************************************************
  const { data: assignments, isLoading, isError } = useGetAssignmentsQuery();
  const [deleteAssignment, { isError: deleteAgnIsError }] =
    useDeleteAssignmentMutation();
  // *****************************************************DECLARATION END******************************************************************************

  // *****************************************************HANDLE START******************************************************************************
  const handleDelete = (aId) => {
    deleteAssignment(aId);
  };
  // *****************************************************HANDLE END******************************************************************************

  // *****************************************************Decided which part render START******************************************************************************

  let content = null;
  let contentLoadingOrError = null;
  if (isLoading) {
    contentLoadingOrError = <Loading />;
  } else if (!isLoading && (isError || deleteAgnIsError)) {
    contentLoadingOrError = (
      <Error
        header="Error !!"
        message="System error contact with administrator"
      />
    );
  } else if (!isLoading && !isError && assignments?.length === 0) {
    contentLoadingOrError = (
      <Error header="" message="No assignment available" />
    );
  } else if (!isLoading && !isError && assignments?.length > 0) {
    content = assignments.map((row, index) => (
      <AssignmentListTr
        row={row}
        key={`${row?.id}_${index}`}
        handleDelete={handleDelete}
      />
    ));
  }
  content = contentLoadingOrError ? (
    contentLoadingOrError
  ) : (
    <Table headers={headers}>{content}</Table>
  );
  // *****************************************************Decided which part render END******************************************************************************

  return (
    <>
      <TableOuterLabel btnText={"Add Assignment"} to={"/admin/addAssignment"} />
      <div className="overflow-x-auto mt-4">{content}</div>
    </>
  );
}
